import { render, staticRenderFns } from "./SafetyStatements.vue?vue&type=template&id=32708c4d&scoped=true"
import script from "./SafetyStatements.vue?vue&type=script&lang=js"
export * from "./SafetyStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32708c4d",
  null
  
)

export default component.exports